export default __webpack_public_path__ + "static/media/id.a5fb3413.svg";